export default {
  title: 'Informații de plată verificate',
  description: 'Informațiile dvs. de plată au fost verificate cu succes.',
};
